import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { SearchRoutingModule } from './search-routing.module';
import { SearchComponent } from './search.component';
import { WebProductComponent } from './components/web-product/web-product.component';
import { WebTableComponent } from './components/web-table/web-table.component';
import { LayoutModule } from '../layout/layout.module';
import { ModalComponent } from '../layout/modal/modal.component';
import { AboutComponent } from '../layout/about/about.component';
import { WidgetModule } from 'src/app/modules/web/components/widget/widget.module';
import { ModalSegurosComponent } from '../Components/modals-seguros.component';


library.add(fab, fas, far)

@NgModule({
  imports: [
    CommonModule,
    SearchRoutingModule,
    LayoutModule,
    WidgetModule,
    NgbModule.forRoot()
  ],
  declarations: [
    SearchComponent,
    WebProductComponent,
    WebTableComponent,
    ModalComponent,
    AboutComponent,
    //ModalSegurosComponent
  ],
  providers: [
    NgbActiveModal
  ],
  entryComponents: [
    ModalComponent
  ]
})
export class SearchModule { }
